import {Button, Col, Form, InputNumber, Row, Select} from 'antd';
import React from 'react';
import EditFormComponent from '../common/EditFormComponent';
import {Arguments} from '../common/Arguments';

const layout = {
	labelCol: {span: 8},
	wrapperCol: {span: 16},
};

const tailLayout = {
	wrapperCol: {offset: 4, span: 16},
};

const DetailEvaluateInformation = () => {
	const apiList = [Arguments.host + '/society_organization/base/branch/api!addEvaluateInformation.do'];

	return (
		<EditFormComponent UserForm={EvaluateInformationForm} url={apiList}/>
	);
};

const EvaluateInformationForm = ({onFinish, initialValues}) => {
	const [form] = Form.useForm();

	return (
		<Form
			{...layout}
			form={form}
			name="control-hooks"
			onFinish={onFinish}
			initialValues={initialValues}
			style={{maxWidth: 1200, marginLeft: 40}}
		>
			<Row align="top">
				<Col span={12}>
					<Form.Item name="year" label="考评年度" rules={[{required: true, message: '内容不能为空'}]}>
						<InputNumber style={{width: 150}} min={0} disabled={true}/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="checkResult" label="考评结果" rules={[{required: true, message: '内容不能为空'}]}
							   initialValue="优秀">
						<Select disabled={true}>
							<Select.Option value="优秀">优秀</Select.Option>
							<Select.Option value="良好">良好</Select.Option>
							<Select.Option value="合格">合格</Select.Option>
							<Select.Option value="不合格">不合格</Select.Option>
						</Select>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="checkContent" label="考评说明" rules={[{required: true, message: '内容不能为空'}]}>
						<div style={{marginTop: 4}} dangerouslySetInnerHTML={{__html: initialValues.checkContent}}/>
					</Form.Item>
				</Col>
			</Row>

			<Form.Item {...tailLayout}>
				<Button
					type="primary"
					htmlType="button"
					onClick={() => {
						window.history.back();
					}}
				>
					返回
				</Button>
			</Form.Item>
		</Form>
	);
};

export default DetailEvaluateInformation;

